<script setup lang="ts">
import { useRoute } from 'vue-router'
import { computed, watch } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { Query } from '@/generated/graphql'
import gql from 'graphql-tag'
import { currentOrganization } from '@/app'
import { organizationInfoFragment } from '@/components/layout/organizationFragments'

const route = useRoute()
const slug = computed(() => route.params.organizationSlug as string | undefined)
const fetchQuery = useQuery<Query>(
  gql`
    query getOrganizationInfo($slug: String!) {
      account {
        organizationBySlug(slug: $slug) {
          ...OrganizationInfo
        }
      }
    }
    ${organizationInfoFragment}
  `,
  () => ({
    slug: slug.value as string,
  }),
  () => ({
    enabled: !!slug.value,
  }),
)
const organization = computed(() => fetchQuery.result.value?.account.organizationBySlug)
watch(
  [organization, slug],
  () => {
    if (!slug.value) {
      currentOrganization.value = undefined
      return
    }

    currentOrganization.value = organization.value
  },
  { immediate: true },
)
</script>

<template>
  <span v-if="!!currentOrganization" class="mr-2 text-overline">
    {{ currentOrganization.name }}
  </span>
</template>

<style scoped lang="scss"></style>
